module.exports = __webpack_public_path__ + "assets/img/sabc_tv_show_slider_left_arrow.webp?2066c6b7e7bc777022fc45bbea3302c7";